<template>
    <svg width="21" height="21" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_576_6)">
        <path d="M8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM4.21875 7.53125C3.925 7.2375 3.925 6.7625 4.21875 6.47188C4.5125 6.18125 4.9875 6.17813 5.27812 6.47188L7.99687 9.19063L10.7156 6.47188C11.0094 6.17813 11.4844 6.17813 11.775 6.47188C12.0656 6.76563 12.0687 7.24062 11.775 7.53125L8.53125 10.7812C8.2375 11.075 7.7625 11.075 7.47188 10.7812L4.21875 7.53125Z" fill="#12760A"/>
        </g>
        <defs>
        <clipPath id="clip0_576_6">
        <rect width="16" height="16" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        
</template>